var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiveMonitoringSessionFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2790_41001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.8381 75.1127C93.0212 57.9296 93.0212 30.0704 75.8381 12.8873C58.655 -4.29577 30.7958 -4.29577 13.6127 12.8873C-3.57037 30.0704 -3.57037 57.9296 13.6127 75.1127C30.7958 92.2958 58.655 92.2958 75.8381 75.1127Z",
    fill: "#F93251"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5196 55.3133C43.6877 55.3133 42.9759 54.6035 42.8315 53.6273L38.5766 24.9293C38.0417 21.3151 40.3766 18.002 43.4579 18.002H45.5792C48.6605 18.002 50.9954 21.3151 50.4605 24.9293L46.2056 53.6273C46.0633 54.6035 45.3514 55.3133 44.5196 55.3133ZM48.4124 66.1091C48.4124 63.9654 46.6633 62.2163 44.5196 62.2163C42.3759 62.2163 40.6267 63.9654 40.6267 66.1091C40.6267 68.2528 42.3759 70.002 44.5196 70.002C46.6633 70.002 48.4124 68.2549 48.4124 66.1091Z",
    fill: "#E6E9ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2790_41001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveMonitoringSessionFailure);
export default __webpack_public_path__ + "static/media/liveMonitoringSessionFailure.c941a3f7cee5fa4aac8ffb2f8e3c9e11.svg";
export { ForwardRef as ReactComponent };